import { Component } from 'react';
import type { Button, CarouselElement } from '../../../types/ChatWindow';
import type { MessageScheme } from '../../../types/configs';
import CarouselButtonList from './CarouselButtonList';

class CarouselCard extends Component<
  {
    index: number;
    handleClick: (...args: any[]) => void;
    element: CarouselElement;
    scheme: MessageScheme;
  },
  unknown
> {
  handleClick = (clickedButton: Button) => {
    const { handleClick } = this.props;
    handleClick(clickedButton);
  };

  render() {
    const {
      element: { image_url: imageUrl, title, subtitle, buttons },
      scheme,
      scheme: { carouselBackgroundColor, carouselTextColor },
    } = this.props;
    return (
      <div className='carousel-card-container'>
        {imageUrl && (
          <div
            className='carousel-card-image'
            style={{
              backgroundImage: `url(${imageUrl})`,
            }}
          />
        )}
        <div
          className='carousel-card-details'
          style={{
            backgroundColor: carouselBackgroundColor,
          }}>
          {title?.length > 0 && (
            <p
              className='carousel-card-title'
              style={{ color: carouselTextColor }}>
              {title}
            </p>
          )}

          {subtitle?.length > 0 && (
            <p
              className='carousel-card-subtitle'
              style={{ color: carouselTextColor }}>
              {subtitle}
            </p>
          )}
          {buttons !== undefined && (
            <CarouselButtonList
              scheme={scheme}
              buttons={buttons}
              onClick={this.handleClick}
            />
          )}
        </div>
      </div>
    );
  }
}

export default CarouselCard;
